/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddTracksRequestRequest,
  ErrorResponse,
  ExportAudioRequestRequest,
  ExportYoutubeVideoRequestRequest,
  NumTracksRequestRequest,
  PaginatedGenerationLogList,
  PaginatedPlaylistListList,
  PaginatedTrackListList,
  PatchedPlaylistUpdateRequest,
  PlaylistCreateRequest,
  PlaylistDetail,
  PlaylistGetLogsParams,
  PlaylistGetTracksParams,
  PlaylistList,
  PlaylistListParams,
  PlaylistRecoverAudioIds200,
  PlaylistRefreshDurations200,
  PlaylistShorts2Params,
  PlaylistShortsParams,
  PlaylistSplitAllSecondVersions200,
  PlaylistStatusResponse,
  PlaylistToggleCompleted200,
  PlaylistUpdate,
  PlaylistUpdateRequest,
  ReorderTracksRequestRequest,
  ShortsUpload,
  TrackDetail,
  TrackUploadRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 현재 사용자의 모든 플레이리스트를 페이지네이션하여 조회합니다.
 * @summary 플레이리스트 목록 조회
 */
export const playlistList = (
  params?: PlaylistListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedPlaylistListList>(
    { url: `/api/playlists/`, method: "GET", params, signal },
    options,
  );
};

export const getPlaylistListQueryKey = (params?: PlaylistListParams) => {
  return [`/api/playlists/`, ...(params ? [params] : [])] as const;
};

export const getPlaylistListQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PlaylistListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlaylistListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof playlistList>>> = ({
    signal,
  }) => playlistList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistListQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistList>>
>;
export type PlaylistListQueryError = ErrorType<ErrorResponse>;

export function usePlaylistList<
  TData = Awaited<ReturnType<typeof playlistList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | PlaylistListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistList>>,
          TError,
          Awaited<ReturnType<typeof playlistList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistList<
  TData = Awaited<ReturnType<typeof playlistList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PlaylistListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistList>>,
          TError,
          Awaited<ReturnType<typeof playlistList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistList<
  TData = Awaited<ReturnType<typeof playlistList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PlaylistListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 플레이리스트 목록 조회
 */

export function usePlaylistList<
  TData = Awaited<ReturnType<typeof playlistList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: PlaylistListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 새 플레이리스트를 생성하고 AI 음악 생성을 시작합니다.
 * @summary 플레이리스트 생성
 */
export const playlistCreate = (
  playlistCreateRequest: BodyType<PlaylistCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistDetail>(
    {
      url: `/api/playlists/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: playlistCreateRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistCreateMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistCreate>>,
    TError,
    { data: BodyType<PlaylistCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistCreate>>,
  TError,
  { data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationKey = ["playlistCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistCreate>>,
    { data: BodyType<PlaylistCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return playlistCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistCreate>>
>;
export type PlaylistCreateMutationBody = BodyType<PlaylistCreateRequest>;
export type PlaylistCreateMutationError = ErrorType<
  ErrorResponse | ErrorResponse
>;

/**
 * @summary 플레이리스트 생성
 */
export const usePlaylistCreate = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistCreate>>,
      TError,
      { data: BodyType<PlaylistCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistCreate>>,
  TError,
  { data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트의 상세 정보와 트랙 목록을 조회합니다.
 * @summary 플레이리스트 상세 조회
 */
export const playlistRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistDetail>(
    { url: `/api/playlists/${id}/`, method: "GET", signal },
    options,
  );
};

export const getPlaylistRetrieveQueryKey = (id?: string) => {
  return [`/api/playlists/${id}/`] as const;
};

export const getPlaylistRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlaylistRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistRetrieve>>
  > = ({ signal }) => playlistRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistRetrieve>>
>;
export type PlaylistRetrieveQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function usePlaylistRetrieve<
  TData = Awaited<ReturnType<typeof playlistRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistRetrieve>>,
          TError,
          Awaited<ReturnType<typeof playlistRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistRetrieve<
  TData = Awaited<ReturnType<typeof playlistRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistRetrieve>>,
          TError,
          Awaited<ReturnType<typeof playlistRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistRetrieve<
  TData = Awaited<ReturnType<typeof playlistRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 플레이리스트 상세 조회
 */

export function usePlaylistRetrieve<
  TData = Awaited<ReturnType<typeof playlistRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트의 모든 필드를 수정합니다.
 * @summary 플레이리스트 전체 수정
 */
export const playlistUpdate = (
  id: string,
  playlistUpdateRequest: BodyType<PlaylistUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<PlaylistDetail>(
    {
      url: `/api/playlists/${id}/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: playlistUpdateRequest,
    },
    options,
  );
};

export const getPlaylistUpdateMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistUpdate>>,
    TError,
    { id: string; data: BodyType<PlaylistUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistUpdate>>,
  TError,
  { id: string; data: BodyType<PlaylistUpdateRequest> },
  TContext
> => {
  const mutationKey = ["playlistUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistUpdate>>,
    { id: string; data: BodyType<PlaylistUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistUpdate>>
>;
export type PlaylistUpdateMutationBody = BodyType<PlaylistUpdateRequest>;
export type PlaylistUpdateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 플레이리스트 전체 수정
 */
export const usePlaylistUpdate = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistUpdate>>,
      TError,
      { id: string; data: BodyType<PlaylistUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistUpdate>>,
  TError,
  { id: string; data: BodyType<PlaylistUpdateRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트의 일부 필드만 수정합니다.
 * @summary 플레이리스트 부분 수정
 */
export const playlistPartialUpdate = (
  id: string,
  patchedPlaylistUpdateRequest: BodyType<PatchedPlaylistUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<PlaylistDetail>(
    {
      url: `/api/playlists/${id}/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedPlaylistUpdateRequest,
    },
    options,
  );
};

export const getPlaylistPartialUpdateMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistPartialUpdate>>,
    TError,
    { id: string; data: BodyType<PatchedPlaylistUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedPlaylistUpdateRequest> },
  TContext
> => {
  const mutationKey = ["playlistPartialUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistPartialUpdate>>,
    { id: string; data: BodyType<PatchedPlaylistUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistPartialUpdate>>
>;
export type PlaylistPartialUpdateMutationBody =
  BodyType<PatchedPlaylistUpdateRequest>;
export type PlaylistPartialUpdateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 플레이리스트 부분 수정
 */
export const usePlaylistPartialUpdate = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistPartialUpdate>>,
      TError,
      { id: string; data: BodyType<PatchedPlaylistUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedPlaylistUpdateRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트를 소프트 삭제합니다.
 * @summary 플레이리스트 삭제
 */
export const playlistDestroy = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/api/playlists/${id}/`, method: "DELETE" },
    options,
  );
};

export const getPlaylistDestroyMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistDestroy>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistDestroy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistDestroy>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistDestroy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistDestroy>>
>;

export type PlaylistDestroyMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 플레이리스트 삭제
 */
export const usePlaylistDestroy = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistDestroy>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPlaylistDestroyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 기존 플레이리스트에 새 트랙을 추가합니다. 참조곡 모드에서는 reference_songs를 전달하면 자동으로 메타데이터가 생성됩니다.
 * @summary 트랙 추가
 */
export const playlistAddTracks = (
  id: string,
  addTracksRequestRequest: BodyType<AddTracksRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/add_tracks/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: addTracksRequestRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistAddTracksMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistAddTracks>>,
    TError,
    { id: string; data: BodyType<AddTracksRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistAddTracks>>,
  TError,
  { id: string; data: BodyType<AddTracksRequestRequest> },
  TContext
> => {
  const mutationKey = ["playlistAddTracks"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistAddTracks>>,
    { id: string; data: BodyType<AddTracksRequestRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistAddTracks(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistAddTracksMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistAddTracks>>
>;
export type PlaylistAddTracksMutationBody = BodyType<AddTracksRequestRequest>;
export type PlaylistAddTracksMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 추가
 */
export const usePlaylistAddTracks = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistAddTracks>>,
      TError,
      { id: string; data: BodyType<AddTracksRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistAddTracks>>,
  TError,
  { id: string; data: BodyType<AddTracksRequestRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistAddTracksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트의 모든 선택된 트랙을 고품질 WAV(16bit/48kHz PCM)로 변환합니다.

Suno API WAV 변환 비용: 0.4 크레딧/곡 (약 $0.002/곡)
 * @summary 트랙 WAV 변환 요청
 */
export const playlistConvertToWav = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/playlists/${id}/convert-to-wav/`, method: "POST", signal },
    options,
  );
};

export const getPlaylistConvertToWavMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistConvertToWav>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistConvertToWav>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistConvertToWav"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistConvertToWav>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistConvertToWav(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistConvertToWavMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistConvertToWav>>
>;

export type PlaylistConvertToWavMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 WAV 변환 요청
 */
export const usePlaylistConvertToWav = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistConvertToWav>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistConvertToWav>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPlaylistConvertToWavMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 업로드된 YouTube 영상을 삭제합니다. Playlist의 youtube_video_id 및 관련 메타가 비워지고 재업로드 가능 상태가 됩니다. 이미 삭제된 영상은 idempotent하게 처리됩니다.
 * @summary YouTube 영상 삭제
 */
export const playlistDeleteYoutubeVideo = (
  id: string,
  playlistCreateRequest: BodyType<PlaylistCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/delete-youtube-video/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: playlistCreateRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistDeleteYoutubeVideoMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistDeleteYoutubeVideo>>,
    TError,
    { id: string; data: BodyType<PlaylistCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistDeleteYoutubeVideo>>,
  TError,
  { id: string; data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationKey = ["playlistDeleteYoutubeVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistDeleteYoutubeVideo>>,
    { id: string; data: BodyType<PlaylistCreateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistDeleteYoutubeVideo(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistDeleteYoutubeVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistDeleteYoutubeVideo>>
>;
export type PlaylistDeleteYoutubeVideoMutationBody =
  BodyType<PlaylistCreateRequest>;
export type PlaylistDeleteYoutubeVideoMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary YouTube 영상 삭제
 */
export const usePlaylistDeleteYoutubeVideo = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistDeleteYoutubeVideo>>,
      TError,
      { id: string; data: BodyType<PlaylistCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistDeleteYoutubeVideo>>,
  TError,
  { id: string; data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistDeleteYoutubeVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트 생성에 필요한 예상 비용을 계산합니다. 서비스별 비용 내역과 사용자 예산 정보를 함께 반환합니다.
 * @summary 생성 비용 추정
 */
export const playlistEstimateCost = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/playlists/${id}/estimate_cost/`, method: "GET", signal },
    options,
  );
};

export const getPlaylistEstimateCostQueryKey = (id?: string) => {
  return [`/api/playlists/${id}/estimate_cost/`] as const;
};

export const getPlaylistEstimateCostQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistEstimateCost>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistEstimateCost>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlaylistEstimateCostQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistEstimateCost>>
  > = ({ signal }) => playlistEstimateCost(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistEstimateCost>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistEstimateCostQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistEstimateCost>>
>;
export type PlaylistEstimateCostQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function usePlaylistEstimateCost<
  TData = Awaited<ReturnType<typeof playlistEstimateCost>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistEstimateCost>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistEstimateCost>>,
          TError,
          Awaited<ReturnType<typeof playlistEstimateCost>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistEstimateCost<
  TData = Awaited<ReturnType<typeof playlistEstimateCost>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistEstimateCost>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistEstimateCost>>,
          TError,
          Awaited<ReturnType<typeof playlistEstimateCost>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistEstimateCost<
  TData = Awaited<ReturnType<typeof playlistEstimateCost>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistEstimateCost>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 생성 비용 추정
 */

export function usePlaylistEstimateCost<
  TData = Awaited<ReturnType<typeof playlistEstimateCost>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistEstimateCost>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistEstimateCostQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트의 모든 트랙 오디오를 하나의 파일로 합쳐서 내보냅니다.

지원 형식: MP3, WAV

**use_wav_source=true** 옵션을 사용하면 고품질 WAV 소스 파일을 사용하여 내보냅니다.
WAV 소스가 없는 트랙은 자동으로 MP3로 폴백됩니다.
 * @summary 오디오 내보내기
 */
export const playlistExportAudio = (
  id: string,
  exportAudioRequestRequest: BodyType<ExportAudioRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/export-audio/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: exportAudioRequestRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistExportAudioMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistExportAudio>>,
    TError,
    { id: string; data: BodyType<ExportAudioRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistExportAudio>>,
  TError,
  { id: string; data: BodyType<ExportAudioRequestRequest> },
  TContext
> => {
  const mutationKey = ["playlistExportAudio"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistExportAudio>>,
    { id: string; data: BodyType<ExportAudioRequestRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistExportAudio(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistExportAudioMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistExportAudio>>
>;
export type PlaylistExportAudioMutationBody =
  BodyType<ExportAudioRequestRequest>;
export type PlaylistExportAudioMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 오디오 내보내기
 */
export const usePlaylistExportAudio = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistExportAudio>>,
      TError,
      { id: string; data: BodyType<ExportAudioRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistExportAudio>>,
  TError,
  { id: string; data: BodyType<ExportAudioRequestRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistExportAudioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * YouTube 업로드에 최적화된 비디오 파일을 생성합니다.

**2K 해상도 (2560x1440)**:
- YouTube에서 최고 음질(256kbps AAC) 재생 가능

**LUFS 정규화**:
- YouTube 표준 라우드니스(-14 LUFS) 적용
 * @summary YouTube 최적화 비디오 내보내기
 */
export const playlistExportYoutubeVideo = (
  id: string,
  exportYoutubeVideoRequestRequest: BodyType<ExportYoutubeVideoRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/export-youtube-video/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: exportYoutubeVideoRequestRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistExportYoutubeVideoMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistExportYoutubeVideo>>,
    TError,
    { id: string; data: BodyType<ExportYoutubeVideoRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistExportYoutubeVideo>>,
  TError,
  { id: string; data: BodyType<ExportYoutubeVideoRequestRequest> },
  TContext
> => {
  const mutationKey = ["playlistExportYoutubeVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistExportYoutubeVideo>>,
    { id: string; data: BodyType<ExportYoutubeVideoRequestRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistExportYoutubeVideo(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistExportYoutubeVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistExportYoutubeVideo>>
>;
export type PlaylistExportYoutubeVideoMutationBody =
  BodyType<ExportYoutubeVideoRequestRequest>;
export type PlaylistExportYoutubeVideoMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary YouTube 최적화 비디오 내보내기
 */
export const usePlaylistExportYoutubeVideo = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistExportYoutubeVideo>>,
      TError,
      { id: string; data: BodyType<ExportYoutubeVideoRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistExportYoutubeVideo>>,
  TError,
  { id: string; data: BodyType<ExportYoutubeVideoRequestRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistExportYoutubeVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 
        플레이리스트 생성 워크플로우(WF1)를 시작합니다.
        Claude API로 메타데이터를 생성하고, Suno API로 음악을 생성합니다.

        Request body (필수):
            {
                "numTracks": 5  // 생성할 트랙 수 (1-50, 필수)
            }

        권장: 새로운 워크플로우인 generate-metadata → start-music-generation을 사용하세요.
        이 액션은 메타데이터와 음악을 한 번에 생성하므로 검토 기회가 없습니다.
        
 * @summary 플레이리스트 생성 시작 (레거시)
 */
export const playlistGenerate = (
  id: string,
  numTracksRequestRequest: BodyType<NumTracksRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/generate/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: numTracksRequestRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistGenerateMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistGenerate>>,
    TError,
    { id: string; data: BodyType<NumTracksRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistGenerate>>,
  TError,
  { id: string; data: BodyType<NumTracksRequestRequest> },
  TContext
> => {
  const mutationKey = ["playlistGenerate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistGenerate>>,
    { id: string; data: BodyType<NumTracksRequestRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistGenerate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistGenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistGenerate>>
>;
export type PlaylistGenerateMutationBody = BodyType<NumTracksRequestRequest>;
export type PlaylistGenerateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 플레이리스트 생성 시작 (레거시)
 */
export const usePlaylistGenerate = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistGenerate>>,
      TError,
      { id: string; data: BodyType<NumTracksRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistGenerate>>,
  TError,
  { id: string; data: BodyType<NumTracksRequestRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistGenerateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 
        Phase 17: 새로운 워크플로우 - 메타데이터만 배치 생성

        단일 Claude API 호출로 모든 트랙의 메타데이터를 생성합니다.
        메타데이터 생성 후 상태가 METADATA_READY로 변경되며,
        사용자가 검토 후 start_music_generation으로 음악 생성을 시작합니다.

        Request body (필수):
            {
                "numTracks": 5  // 생성할 트랙 수 (1-50, 필수)
            }
        
 * @summary 메타데이터만 생성 (배치)
 */
export const playlistGenerateMetadata = (
  id: string,
  numTracksRequestRequest: BodyType<NumTracksRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/generate-metadata/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: numTracksRequestRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistGenerateMetadataMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistGenerateMetadata>>,
    TError,
    { id: string; data: BodyType<NumTracksRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistGenerateMetadata>>,
  TError,
  { id: string; data: BodyType<NumTracksRequestRequest> },
  TContext
> => {
  const mutationKey = ["playlistGenerateMetadata"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistGenerateMetadata>>,
    { id: string; data: BodyType<NumTracksRequestRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistGenerateMetadata(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistGenerateMetadataMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistGenerateMetadata>>
>;
export type PlaylistGenerateMetadataMutationBody =
  BodyType<NumTracksRequestRequest>;
export type PlaylistGenerateMetadataMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 메타데이터만 생성 (배치)
 */
export const usePlaylistGenerateMetadata = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistGenerateMetadata>>,
      TError,
      { id: string; data: BodyType<NumTracksRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistGenerateMetadata>>,
  TError,
  { id: string; data: BodyType<NumTracksRequestRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistGenerateMetadataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * DALL-E API를 사용하여 플레이리스트 테마, 분위기, 장르에 맞는 커버 이미지를 생성합니다.
 * @summary AI 커버 이미지 생성
 */
export const playlistGenerateCoverImage = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/generate_cover_image/`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getPlaylistGenerateCoverImageMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistGenerateCoverImage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistGenerateCoverImage>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistGenerateCoverImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistGenerateCoverImage>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistGenerateCoverImage(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistGenerateCoverImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistGenerateCoverImage>>
>;

export type PlaylistGenerateCoverImageMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary AI 커버 이미지 생성
 */
export const usePlaylistGenerateCoverImage = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistGenerateCoverImage>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistGenerateCoverImage>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPlaylistGenerateCoverImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 완료된 플레이리스트의 모든 트랙을 결합하여 비디오를 생성합니다. WF2 워크플로우를 시작합니다.
 * @summary 비디오 생성
 */
export const playlistGenerateVideo = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/playlists/${id}/generate_video/`, method: "POST", signal },
    options,
  );
};

export const getPlaylistGenerateVideoMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistGenerateVideo>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistGenerateVideo>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistGenerateVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistGenerateVideo>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistGenerateVideo(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistGenerateVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistGenerateVideo>>
>;

export type PlaylistGenerateVideoMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 비디오 생성
 */
export const usePlaylistGenerateVideo = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistGenerateVideo>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistGenerateVideo>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPlaylistGenerateVideoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Claude API를 사용하여 SEO 최적화된 YouTube 제목, 설명, 태그를 생성합니다.
 * @summary YouTube 메타데이터 생성
 */
export const playlistGenerateYoutubeMetadata = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/generate_youtube_metadata/`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getPlaylistGenerateYoutubeMetadataMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistGenerateYoutubeMetadata>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistGenerateYoutubeMetadata>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistGenerateYoutubeMetadata"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistGenerateYoutubeMetadata>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistGenerateYoutubeMetadata(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistGenerateYoutubeMetadataMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistGenerateYoutubeMetadata>>
>;

export type PlaylistGenerateYoutubeMetadataMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary YouTube 메타데이터 생성
 */
export const usePlaylistGenerateYoutubeMetadata = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistGenerateYoutubeMetadata>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistGenerateYoutubeMetadata>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getPlaylistGenerateYoutubeMetadataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트의 생성 로그를 페이지네이션하여 조회합니다.
 * @summary 플레이리스트 생성 로그 조회
 */
export const playlistGetLogs = (
  id: string,
  params?: PlaylistGetLogsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedGenerationLogList>(
    { url: `/api/playlists/${id}/logs/`, method: "GET", params, signal },
    options,
  );
};

export const getPlaylistGetLogsQueryKey = (
  id?: string,
  params?: PlaylistGetLogsParams,
) => {
  return [`/api/playlists/${id}/logs/`, ...(params ? [params] : [])] as const;
};

export const getPlaylistGetLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistGetLogs>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistGetLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlaylistGetLogsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof playlistGetLogs>>> = ({
    signal,
  }) => playlistGetLogs(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistGetLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistGetLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistGetLogs>>
>;
export type PlaylistGetLogsQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function usePlaylistGetLogs<
  TData = Awaited<ReturnType<typeof playlistGetLogs>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params: undefined | PlaylistGetLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistGetLogs>>,
          TError,
          Awaited<ReturnType<typeof playlistGetLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistGetLogs<
  TData = Awaited<ReturnType<typeof playlistGetLogs>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistGetLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistGetLogs>>,
          TError,
          Awaited<ReturnType<typeof playlistGetLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistGetLogs<
  TData = Awaited<ReturnType<typeof playlistGetLogs>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistGetLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 플레이리스트 생성 로그 조회
 */

export function usePlaylistGetLogs<
  TData = Awaited<ReturnType<typeof playlistGetLogs>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistGetLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistGetLogsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 
        플레이리스트 트랙의 누락된 suno_audio_id를 metadata에서 복구합니다.

        - metadata에 저장된 suno_audio_id를 TrackVersion 필드에 복원합니다.
        - convert_wav=true 옵션으로 복구 후 WAV 변환을 자동 트리거할 수 있습니다.
        - 관리자 또는 플레이리스트 소유자만 사용 가능합니다.
        
 * @summary 누락된 suno_audio_id 복구
 */
export const playlistRecoverAudioIds = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistRecoverAudioIds200>(
    { url: `/api/playlists/${id}/recover-audio-ids/`, method: "POST", signal },
    options,
  );
};

export const getPlaylistRecoverAudioIdsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistRecoverAudioIds>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistRecoverAudioIds>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistRecoverAudioIds"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistRecoverAudioIds>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistRecoverAudioIds(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistRecoverAudioIdsMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistRecoverAudioIds>>
>;

export type PlaylistRecoverAudioIdsMutationError = ErrorType<unknown>;

/**
 * @summary 누락된 suno_audio_id 복구
 */
export const usePlaylistRecoverAudioIds = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistRecoverAudioIds>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistRecoverAudioIds>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPlaylistRecoverAudioIdsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 오디오 URL이 있지만 재생시간이 0인 트랙 버전들의 재생시간을 ffprobe로 다시 확인합니다.
 * @summary 트랙 버전 재생시간 새로고침
 */
export const playlistRefreshDurations = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistRefreshDurations200>(
    { url: `/api/playlists/${id}/refresh-durations/`, method: "POST", signal },
    options,
  );
};

export const getPlaylistRefreshDurationsMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistRefreshDurations>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistRefreshDurations>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistRefreshDurations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistRefreshDurations>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistRefreshDurations(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistRefreshDurationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistRefreshDurations>>
>;

export type PlaylistRefreshDurationsMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 버전 재생시간 새로고침
 */
export const usePlaylistRefreshDurations = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistRefreshDurations>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistRefreshDurations>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPlaylistRefreshDurationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * YouTube Data API v3를 직접 호출하여 view/like/comment count를 즉시 갱신합니다. youtube_video_id가 있는 발행된 플레이리스트에서만 사용 가능. Throttle: 사용자당 시간당 20회 (quota 보호).
 * @summary YouTube 비디오 통계 강제 새로고침
 */
export const playlistRefreshYoutubeStats = (
  id: string,
  playlistCreateRequest: BodyType<PlaylistCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/refresh-youtube-stats/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: playlistCreateRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistRefreshYoutubeStatsMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistRefreshYoutubeStats>>,
    TError,
    { id: string; data: BodyType<PlaylistCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistRefreshYoutubeStats>>,
  TError,
  { id: string; data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationKey = ["playlistRefreshYoutubeStats"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistRefreshYoutubeStats>>,
    { id: string; data: BodyType<PlaylistCreateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistRefreshYoutubeStats(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistRefreshYoutubeStatsMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistRefreshYoutubeStats>>
>;
export type PlaylistRefreshYoutubeStatsMutationBody =
  BodyType<PlaylistCreateRequest>;
export type PlaylistRefreshYoutubeStatsMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary YouTube 비디오 통계 강제 새로고침
 */
export const usePlaylistRefreshYoutubeStats = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistRefreshYoutubeStats>>,
      TError,
      { id: string; data: BodyType<PlaylistCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistRefreshYoutubeStats>>,
  TError,
  { id: string; data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationOptions =
    getPlaylistRefreshYoutubeStatsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 
        실패, 완료, 또는 중단된 플레이리스트를 재생성합니다.
        기존 트랙과 로그를 삭제하고 WF1 워크플로우를 다시 시작합니다.

        Request body (필수):
            {
                "numTracks": 5  // 생성할 트랙 수 (1-50, 필수)
            }

        권장: 새로운 워크플로우인 generate-metadata → start-music-generation을 사용하세요.
        
 * @summary 플레이리스트 재생성 (레거시)
 */
export const playlistRegenerate = (
  id: string,
  numTracksRequestRequest: BodyType<NumTracksRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/regenerate/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: numTracksRequestRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistRegenerateMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistRegenerate>>,
    TError,
    { id: string; data: BodyType<NumTracksRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistRegenerate>>,
  TError,
  { id: string; data: BodyType<NumTracksRequestRequest> },
  TContext
> => {
  const mutationKey = ["playlistRegenerate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistRegenerate>>,
    { id: string; data: BodyType<NumTracksRequestRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistRegenerate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistRegenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistRegenerate>>
>;
export type PlaylistRegenerateMutationBody = BodyType<NumTracksRequestRequest>;
export type PlaylistRegenerateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 플레이리스트 재생성 (레거시)
 */
export const usePlaylistRegenerate = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistRegenerate>>,
      TError,
      { id: string; data: BodyType<NumTracksRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistRegenerate>>,
  TError,
  { id: string; data: BodyType<NumTracksRequestRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistRegenerateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트 내 트랙의 순서를 변경합니다. 제공된 트랙 ID 목록의 순서대로 track_number가 재할당됩니다.
 * @summary 트랙 순서 변경
 */
export const playlistReorderTracks = (
  id: string,
  reorderTracksRequestRequest: BodyType<ReorderTracksRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/reorder-tracks/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: reorderTracksRequestRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistReorderTracksMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistReorderTracks>>,
    TError,
    { id: string; data: BodyType<ReorderTracksRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistReorderTracks>>,
  TError,
  { id: string; data: BodyType<ReorderTracksRequestRequest> },
  TContext
> => {
  const mutationKey = ["playlistReorderTracks"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistReorderTracks>>,
    { id: string; data: BodyType<ReorderTracksRequestRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistReorderTracks(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistReorderTracksMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistReorderTracks>>
>;
export type PlaylistReorderTracksMutationBody =
  BodyType<ReorderTracksRequestRequest>;
export type PlaylistReorderTracksMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 트랙 순서 변경
 */
export const usePlaylistReorderTracks = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistReorderTracks>>,
      TError,
      { id: string; data: BodyType<ReorderTracksRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistReorderTracks>>,
  TError,
  { id: string; data: BodyType<ReorderTracksRequestRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistReorderTracksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * GET: 플레이리스트에 속한 트랙별 Shorts 업로드 이력 + 통계 캐시를 반환합니다. 트랙 번호 오름차순, 업로드 시각 내림차순. 최대 500건. Phase 1은 YouTube Shorts만 활성.
POST: Streamlit 업로드 페이지 등에서 직접 업로드한 Shorts를 등록합니다. body: {track_id, youtube_video_id, used_hook, used_template, used_language}
 * @summary 플레이리스트의 Shorts 업로드 목록 조회 / 등록
 */
export const playlistShorts = (
  id: string,
  params?: PlaylistShortsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ShortsUpload[] | ShortsUpload>(
    { url: `/api/playlists/${id}/shorts/`, method: "GET", params, signal },
    options,
  );
};

export const getPlaylistShortsQueryKey = (
  id?: string,
  params?: PlaylistShortsParams,
) => {
  return [`/api/playlists/${id}/shorts/`, ...(params ? [params] : [])] as const;
};

export const getPlaylistShortsQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistShorts>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistShortsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistShorts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlaylistShortsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof playlistShorts>>> = ({
    signal,
  }) => playlistShorts(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistShorts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistShortsQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistShorts>>
>;
export type PlaylistShortsQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function usePlaylistShorts<
  TData = Awaited<ReturnType<typeof playlistShorts>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params: undefined | PlaylistShortsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistShorts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistShorts>>,
          TError,
          Awaited<ReturnType<typeof playlistShorts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistShorts<
  TData = Awaited<ReturnType<typeof playlistShorts>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistShortsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistShorts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistShorts>>,
          TError,
          Awaited<ReturnType<typeof playlistShorts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistShorts<
  TData = Awaited<ReturnType<typeof playlistShorts>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistShortsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistShorts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 플레이리스트의 Shorts 업로드 목록 조회 / 등록
 */

export function usePlaylistShorts<
  TData = Awaited<ReturnType<typeof playlistShorts>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistShortsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playlistShorts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistShortsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * GET: 플레이리스트에 속한 트랙별 Shorts 업로드 이력 + 통계 캐시를 반환합니다. 트랙 번호 오름차순, 업로드 시각 내림차순. 최대 500건. Phase 1은 YouTube Shorts만 활성.
POST: Streamlit 업로드 페이지 등에서 직접 업로드한 Shorts를 등록합니다. body: {track_id, youtube_video_id, used_hook, used_template, used_language}
 * @summary 플레이리스트의 Shorts 업로드 목록 조회 / 등록
 */
export const playlistShorts2 = (
  id: string,
  playlistCreateRequest: BodyType<PlaylistCreateRequest>,
  params?: PlaylistShorts2Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ShortsUpload[] | ShortsUpload>(
    {
      url: `/api/playlists/${id}/shorts/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: playlistCreateRequest,
      params,
      signal,
    },
    options,
  );
};

export const getPlaylistShorts2MutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistShorts2>>,
    TError,
    {
      id: string;
      data: BodyType<PlaylistCreateRequest>;
      params?: PlaylistShorts2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistShorts2>>,
  TError,
  {
    id: string;
    data: BodyType<PlaylistCreateRequest>;
    params?: PlaylistShorts2Params;
  },
  TContext
> => {
  const mutationKey = ["playlistShorts2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistShorts2>>,
    {
      id: string;
      data: BodyType<PlaylistCreateRequest>;
      params?: PlaylistShorts2Params;
    }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return playlistShorts2(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistShorts2MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistShorts2>>
>;
export type PlaylistShorts2MutationBody = BodyType<PlaylistCreateRequest>;
export type PlaylistShorts2MutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 플레이리스트의 Shorts 업로드 목록 조회 / 등록
 */
export const usePlaylistShorts2 = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistShorts2>>,
      TError,
      {
        id: string;
        data: BodyType<PlaylistCreateRequest>;
        params?: PlaylistShorts2Params;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistShorts2>>,
  TError,
  {
    id: string;
    data: BodyType<PlaylistCreateRequest>;
    params?: PlaylistShorts2Params;
  },
  TContext
> => {
  const mutationOptions = getPlaylistShorts2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트의 숏폼 9:16 크롭/포컬 구성(배경별 xPct·yPct·zoom)을 조회(GET)하거나 저장(PUT)합니다. 렌더러가 롱폼 16:9 배경을 세로 숏폼으로 잘라낼 때 센터크롭 대신 이 포컬 윈도우를 사용합니다.
 * @summary 숏폼 9:16 크롭 에디터 구성 조회/저장
 */
export const playlistShortsEditorConfig = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistList>(
    {
      url: `/api/playlists/${id}/shorts-editor-config/`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getPlaylistShortsEditorConfigQueryKey = (id?: string) => {
  return [`/api/playlists/${id}/shorts-editor-config/`] as const;
};

export const getPlaylistShortsEditorConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlaylistShortsEditorConfigQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistShortsEditorConfig>>
  > = ({ signal }) => playlistShortsEditorConfig(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistShortsEditorConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistShortsEditorConfig>>
>;
export type PlaylistShortsEditorConfigQueryError = ErrorType<unknown>;

export function usePlaylistShortsEditorConfig<
  TData = Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
          TError,
          Awaited<ReturnType<typeof playlistShortsEditorConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistShortsEditorConfig<
  TData = Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
          TError,
          Awaited<ReturnType<typeof playlistShortsEditorConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistShortsEditorConfig<
  TData = Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 숏폼 9:16 크롭 에디터 구성 조회/저장
 */

export function usePlaylistShortsEditorConfig<
  TData = Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistShortsEditorConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistShortsEditorConfigQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트의 숏폼 9:16 크롭/포컬 구성(배경별 xPct·yPct·zoom)을 조회(GET)하거나 저장(PUT)합니다. 렌더러가 롱폼 16:9 배경을 세로 숏폼으로 잘라낼 때 센터크롭 대신 이 포컬 윈도우를 사용합니다.
 * @summary 숏폼 9:16 크롭 에디터 구성 조회/저장
 */
export const playlistShortsEditorConfig2 = (
  id: string,
  playlistUpdateRequest: BodyType<PlaylistUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<PlaylistUpdate>(
    {
      url: `/api/playlists/${id}/shorts-editor-config/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: playlistUpdateRequest,
    },
    options,
  );
};

export const getPlaylistShortsEditorConfig2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistShortsEditorConfig2>>,
    TError,
    { id: string; data: BodyType<PlaylistUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistShortsEditorConfig2>>,
  TError,
  { id: string; data: BodyType<PlaylistUpdateRequest> },
  TContext
> => {
  const mutationKey = ["playlistShortsEditorConfig2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistShortsEditorConfig2>>,
    { id: string; data: BodyType<PlaylistUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistShortsEditorConfig2(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistShortsEditorConfig2MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistShortsEditorConfig2>>
>;
export type PlaylistShortsEditorConfig2MutationBody =
  BodyType<PlaylistUpdateRequest>;
export type PlaylistShortsEditorConfig2MutationError = ErrorType<unknown>;

/**
 * @summary 숏폼 9:16 크롭 에디터 구성 조회/저장
 */
export const usePlaylistShortsEditorConfig2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistShortsEditorConfig2>>,
      TError,
      { id: string; data: BodyType<PlaylistUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistShortsEditorConfig2>>,
  TError,
  { id: string; data: BodyType<PlaylistUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getPlaylistShortsEditorConfig2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 현재 playlist의 모든 Track(track_number 오름차순)을 순회하여, version_number=2 + audio_url이 있는 TrackVersion을 새 Track으로 분리합니다. 분리된 Track은 기존 playlist 끝에 순차 배치. 트랙별 try/except로 부분 성공 허용 (1개 실패해도 나머지 진행). Idempotent — 재실행 시 이미 분리된 트랙은 스킵.
 * @summary 모든 트랙의 2번째 버전 일괄 분리
 */
export const playlistSplitAllSecondVersions = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistSplitAllSecondVersions200>(
    {
      url: `/api/playlists/${id}/split-all-second-versions/`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getPlaylistSplitAllSecondVersionsMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistSplitAllSecondVersions>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistSplitAllSecondVersions>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistSplitAllSecondVersions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistSplitAllSecondVersions>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistSplitAllSecondVersions(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistSplitAllSecondVersionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistSplitAllSecondVersions>>
>;

export type PlaylistSplitAllSecondVersionsMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 모든 트랙의 2번째 버전 일괄 분리
 */
export const usePlaylistSplitAllSecondVersions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistSplitAllSecondVersions>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistSplitAllSecondVersions>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getPlaylistSplitAllSecondVersionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 
        Phase 17: 메타데이터 검토 후 음악 생성 시작

        METADATA_READY 상태의 플레이리스트에서 음악 생성을 시작합니다.
        
 * @summary 음악 생성 시작 (메타데이터 검토 후)
 */
export const playlistStartMusicGeneration = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/start-music-generation/`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getPlaylistStartMusicGenerationMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistStartMusicGeneration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistStartMusicGeneration>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistStartMusicGeneration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistStartMusicGeneration>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistStartMusicGeneration(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistStartMusicGenerationMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistStartMusicGeneration>>
>;

export type PlaylistStartMusicGenerationMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 음악 생성 시작 (메타데이터 검토 후)
 */
export const usePlaylistStartMusicGeneration = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistStartMusicGeneration>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistStartMusicGeneration>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getPlaylistStartMusicGenerationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트의 상세 생성 상태를 조회합니다. 10초 캐싱이 적용됩니다.
 * @summary 플레이리스트 생성 상태 조회
 */
export const playlistGetStatus = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistStatusResponse>(
    { url: `/api/playlists/${id}/status/`, method: "GET", signal },
    options,
  );
};

export const getPlaylistGetStatusQueryKey = (id?: string) => {
  return [`/api/playlists/${id}/status/`] as const;
};

export const getPlaylistGetStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistGetStatus>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlaylistGetStatusQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistGetStatus>>
  > = ({ signal }) => playlistGetStatus(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistGetStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistGetStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistGetStatus>>
>;
export type PlaylistGetStatusQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function usePlaylistGetStatus<
  TData = Awaited<ReturnType<typeof playlistGetStatus>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistGetStatus>>,
          TError,
          Awaited<ReturnType<typeof playlistGetStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistGetStatus<
  TData = Awaited<ReturnType<typeof playlistGetStatus>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistGetStatus>>,
          TError,
          Awaited<ReturnType<typeof playlistGetStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistGetStatus<
  TData = Awaited<ReturnType<typeof playlistGetStatus>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 플레이리스트 생성 상태 조회
 */

export function usePlaylistGetStatus<
  TData = Awaited<ReturnType<typeof playlistGetStatus>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistGetStatusQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트의 썸네일 에디터 레이어 구성(레이아웃·폰트·색·visible)을 조회(GET)하거나 저장(PUT)합니다. 다른 플리에서 이 구성을 불러와 룩을 재사용합니다.
 * @summary 썸네일 에디터 구성 조회/저장
 */
export const playlistThumbnailEditorConfig = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistList>(
    {
      url: `/api/playlists/${id}/thumbnail-editor-config/`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getPlaylistThumbnailEditorConfigQueryKey = (id?: string) => {
  return [`/api/playlists/${id}/thumbnail-editor-config/`] as const;
};

export const getPlaylistThumbnailEditorConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlaylistThumbnailEditorConfigQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>
  > = ({ signal }) => playlistThumbnailEditorConfig(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistThumbnailEditorConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>
>;
export type PlaylistThumbnailEditorConfigQueryError = ErrorType<unknown>;

export function usePlaylistThumbnailEditorConfig<
  TData = Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
          TError,
          Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistThumbnailEditorConfig<
  TData = Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
          TError,
          Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistThumbnailEditorConfig<
  TData = Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 썸네일 에디터 구성 조회/저장
 */

export function usePlaylistThumbnailEditorConfig<
  TData = Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistThumbnailEditorConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistThumbnailEditorConfigQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트의 썸네일 에디터 레이어 구성(레이아웃·폰트·색·visible)을 조회(GET)하거나 저장(PUT)합니다. 다른 플리에서 이 구성을 불러와 룩을 재사용합니다.
 * @summary 썸네일 에디터 구성 조회/저장
 */
export const playlistThumbnailEditorConfig2 = (
  id: string,
  playlistUpdateRequest: BodyType<PlaylistUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<PlaylistUpdate>(
    {
      url: `/api/playlists/${id}/thumbnail-editor-config/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: playlistUpdateRequest,
    },
    options,
  );
};

export const getPlaylistThumbnailEditorConfig2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistThumbnailEditorConfig2>>,
    TError,
    { id: string; data: BodyType<PlaylistUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistThumbnailEditorConfig2>>,
  TError,
  { id: string; data: BodyType<PlaylistUpdateRequest> },
  TContext
> => {
  const mutationKey = ["playlistThumbnailEditorConfig2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistThumbnailEditorConfig2>>,
    { id: string; data: BodyType<PlaylistUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistThumbnailEditorConfig2(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistThumbnailEditorConfig2MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistThumbnailEditorConfig2>>
>;
export type PlaylistThumbnailEditorConfig2MutationBody =
  BodyType<PlaylistUpdateRequest>;
export type PlaylistThumbnailEditorConfig2MutationError = ErrorType<unknown>;

/**
 * @summary 썸네일 에디터 구성 조회/저장
 */
export const usePlaylistThumbnailEditorConfig2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistThumbnailEditorConfig2>>,
      TError,
      { id: string; data: BodyType<PlaylistUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistThumbnailEditorConfig2>>,
  TError,
  { id: string; data: BodyType<PlaylistUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getPlaylistThumbnailEditorConfig2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 
        플레이리스트의 완료 상태를 토글합니다.

        - completed 상태 → pending 상태로 변경 (완료 해제)
        - 그 외 상태 → completed 상태로 변경 (수동 완료 처리)

        수동으로 트랙을 등록한 경우나, 테스트 목적으로 사용할 수 있습니다.
        
 * @summary 플레이리스트 완료 상태 토글
 */
export const playlistToggleCompleted = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistToggleCompleted200>(
    { url: `/api/playlists/${id}/toggle-completed/`, method: "POST", signal },
    options,
  );
};

export const getPlaylistToggleCompletedMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistToggleCompleted>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistToggleCompleted>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistToggleCompleted"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistToggleCompleted>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistToggleCompleted(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistToggleCompletedMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistToggleCompleted>>
>;

export type PlaylistToggleCompletedMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 플레이리스트 완료 상태 토글
 */
export const usePlaylistToggleCompleted = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistToggleCompleted>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistToggleCompleted>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPlaylistToggleCompletedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트의 트랙 목록을 반환합니다. detail 페이지의 reorder/분리 UX를 위해 기본 page_size=1000(최대 1000)으로 전체 트랙을 한 번에 반환합니다.
 * @summary 플레이리스트 트랙 목록 조회
 */
export const playlistGetTracks = (
  id: string,
  params?: PlaylistGetTracksParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedTrackListList>(
    { url: `/api/playlists/${id}/tracks/`, method: "GET", params, signal },
    options,
  );
};

export const getPlaylistGetTracksQueryKey = (
  id?: string,
  params?: PlaylistGetTracksParams,
) => {
  return [`/api/playlists/${id}/tracks/`, ...(params ? [params] : [])] as const;
};

export const getPlaylistGetTracksQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistGetTracks>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistGetTracksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetTracks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlaylistGetTracksQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistGetTracks>>
  > = ({ signal }) => playlistGetTracks(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistGetTracks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistGetTracksQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistGetTracks>>
>;
export type PlaylistGetTracksQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function usePlaylistGetTracks<
  TData = Awaited<ReturnType<typeof playlistGetTracks>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params: undefined | PlaylistGetTracksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetTracks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistGetTracks>>,
          TError,
          Awaited<ReturnType<typeof playlistGetTracks>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistGetTracks<
  TData = Awaited<ReturnType<typeof playlistGetTracks>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistGetTracksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetTracks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistGetTracks>>,
          TError,
          Awaited<ReturnType<typeof playlistGetTracks>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistGetTracks<
  TData = Awaited<ReturnType<typeof playlistGetTracks>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistGetTracksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetTracks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 플레이리스트 트랙 목록 조회
 */

export function usePlaylistGetTracks<
  TData = Awaited<ReturnType<typeof playlistGetTracks>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistGetTracksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistGetTracks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistGetTracksQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트의 커버 이미지를 제거합니다 (cover_image_url을 빈 값으로 초기화). 이미 없으면 idempotent 200. 실제 storage 파일은 orphan으로 남깁니다.
 * @summary 커버 이미지 삭제
 */
export const playlistDeleteCoverImage = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/api/playlists/${id}/upload-cover-image/`, method: "DELETE" },
    options,
  );
};

export const getPlaylistDeleteCoverImageMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistDeleteCoverImage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistDeleteCoverImage>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistDeleteCoverImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistDeleteCoverImage>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistDeleteCoverImage(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistDeleteCoverImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistDeleteCoverImage>>
>;

export type PlaylistDeleteCoverImageMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 커버 이미지 삭제
 */
export const usePlaylistDeleteCoverImage = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistDeleteCoverImage>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistDeleteCoverImage>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPlaylistDeleteCoverImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 
        MP3 오디오 파일을 업로드하여 플레이리스트에 트랙을 직접 추가합니다.

        - AI 생성 없이 직접 음악 파일을 업로드합니다.
        - MP3 형식만 지원합니다.
        - 업로드된 트랙은 source='uploaded'로 표시됩니다.
        - 트랙 번호는 자동으로 할당됩니다 (마지막 번호 + 1).
        
 * @summary 플레이리스트에 트랙 직접 업로드
 */
export const playlistUploadTrack = (
  id: string,
  trackUploadRequest: BodyType<TrackUploadRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackDetail>(
    {
      url: `/api/playlists/${id}/upload-track/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: trackUploadRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistUploadTrackMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistUploadTrack>>,
    TError,
    { id: string; data: BodyType<TrackUploadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistUploadTrack>>,
  TError,
  { id: string; data: BodyType<TrackUploadRequest> },
  TContext
> => {
  const mutationKey = ["playlistUploadTrack"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistUploadTrack>>,
    { id: string; data: BodyType<TrackUploadRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistUploadTrack(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistUploadTrackMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistUploadTrack>>
>;
export type PlaylistUploadTrackMutationBody = BodyType<TrackUploadRequest>;
export type PlaylistUploadTrackMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 플레이리스트에 트랙 직접 업로드
 */
export const usePlaylistUploadTrack = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistUploadTrack>>,
      TError,
      { id: string; data: BodyType<TrackUploadRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistUploadTrack>>,
  TError,
  { id: string; data: BodyType<TrackUploadRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistUploadTrackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트에 커스텀 커버 이미지를 업로드합니다. 지원 형식: JPG, PNG, WebP. 최대 크기: 5MB.
 * @summary 커버 이미지 업로드
 */
export const playlistUploadCoverImage = (
  id: string,
  playlistCreateRequest: BodyType<PlaylistCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/upload_cover_image/`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: playlistCreateRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistUploadCoverImageMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistUploadCoverImage>>,
    TError,
    { id: string; data: BodyType<PlaylistCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistUploadCoverImage>>,
  TError,
  { id: string; data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationKey = ["playlistUploadCoverImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistUploadCoverImage>>,
    { id: string; data: BodyType<PlaylistCreateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistUploadCoverImage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistUploadCoverImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistUploadCoverImage>>
>;
export type PlaylistUploadCoverImageMutationBody =
  BodyType<PlaylistCreateRequest>;
export type PlaylistUploadCoverImageMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 커버 이미지 업로드
 */
export const usePlaylistUploadCoverImage = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistUploadCoverImage>>,
      TError,
      { id: string; data: BodyType<PlaylistCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistUploadCoverImage>>,
  TError,
  { id: string; data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistUploadCoverImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트의 영상 오버레이 타임라인 구성(텍스트·이미지 오버레이, startSec~endSec·페이드·위치·크기)을 조회(GET)하거나 저장(PUT)합니다. 렌더러가 숏폼·롱폼 프레임 위에 이 오버레이를 합성합니다.
 * @summary 영상 오버레이 타임라인 구성 조회/저장
 */
export const playlistVideoOverlaysConfig = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistList>(
    {
      url: `/api/playlists/${id}/video-overlays-config/`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getPlaylistVideoOverlaysConfigQueryKey = (id?: string) => {
  return [`/api/playlists/${id}/video-overlays-config/`] as const;
};

export const getPlaylistVideoOverlaysConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlaylistVideoOverlaysConfigQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>
  > = ({ signal }) => playlistVideoOverlaysConfig(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistVideoOverlaysConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>
>;
export type PlaylistVideoOverlaysConfigQueryError = ErrorType<unknown>;

export function usePlaylistVideoOverlaysConfig<
  TData = Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
          TError,
          Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistVideoOverlaysConfig<
  TData = Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
          TError,
          Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistVideoOverlaysConfig<
  TData = Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 영상 오버레이 타임라인 구성 조회/저장
 */

export function usePlaylistVideoOverlaysConfig<
  TData = Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistVideoOverlaysConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistVideoOverlaysConfigQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트의 영상 오버레이 타임라인 구성(텍스트·이미지 오버레이, startSec~endSec·페이드·위치·크기)을 조회(GET)하거나 저장(PUT)합니다. 렌더러가 숏폼·롱폼 프레임 위에 이 오버레이를 합성합니다.
 * @summary 영상 오버레이 타임라인 구성 조회/저장
 */
export const playlistVideoOverlaysConfig2 = (
  id: string,
  playlistUpdateRequest: BodyType<PlaylistUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<PlaylistUpdate>(
    {
      url: `/api/playlists/${id}/video-overlays-config/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: playlistUpdateRequest,
    },
    options,
  );
};

export const getPlaylistVideoOverlaysConfig2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistVideoOverlaysConfig2>>,
    TError,
    { id: string; data: BodyType<PlaylistUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistVideoOverlaysConfig2>>,
  TError,
  { id: string; data: BodyType<PlaylistUpdateRequest> },
  TContext
> => {
  const mutationKey = ["playlistVideoOverlaysConfig2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistVideoOverlaysConfig2>>,
    { id: string; data: BodyType<PlaylistUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistVideoOverlaysConfig2(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistVideoOverlaysConfig2MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistVideoOverlaysConfig2>>
>;
export type PlaylistVideoOverlaysConfig2MutationBody =
  BodyType<PlaylistUpdateRequest>;
export type PlaylistVideoOverlaysConfig2MutationError = ErrorType<unknown>;

/**
 * @summary 영상 오버레이 타임라인 구성 조회/저장
 */
export const usePlaylistVideoOverlaysConfig2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistVideoOverlaysConfig2>>,
      TError,
      { id: string; data: BodyType<PlaylistUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistVideoOverlaysConfig2>>,
  TError,
  { id: string; data: BodyType<PlaylistUpdateRequest> },
  TContext
> => {
  const mutationOptions =
    getPlaylistVideoOverlaysConfig2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 플레이리스트의 WAV 변환 진행 상황을 조회합니다.

각 트랙의 변환 상태와 전체 진행률을 반환합니다.
 * @summary WAV 변환 진행 상황 조회
 */
export const playlistWavConversionProgress = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/wav-conversion-progress/`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getPlaylistWavConversionProgressQueryKey = (id?: string) => {
  return [`/api/playlists/${id}/wav-conversion-progress/`] as const;
};

export const getPlaylistWavConversionProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistWavConversionProgress>>,
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistWavConversionProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlaylistWavConversionProgressQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistWavConversionProgress>>
  > = ({ signal }) => playlistWavConversionProgress(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistWavConversionProgress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistWavConversionProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistWavConversionProgress>>
>;
export type PlaylistWavConversionProgressQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

export function usePlaylistWavConversionProgress<
  TData = Awaited<ReturnType<typeof playlistWavConversionProgress>>,
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistWavConversionProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistWavConversionProgress>>,
          TError,
          Awaited<ReturnType<typeof playlistWavConversionProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistWavConversionProgress<
  TData = Awaited<ReturnType<typeof playlistWavConversionProgress>>,
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistWavConversionProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistWavConversionProgress>>,
          TError,
          Awaited<ReturnType<typeof playlistWavConversionProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistWavConversionProgress<
  TData = Awaited<ReturnType<typeof playlistWavConversionProgress>>,
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistWavConversionProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary WAV 변환 진행 상황 조회
 */

export function usePlaylistWavConversionProgress<
  TData = Awaited<ReturnType<typeof playlistWavConversionProgress>>,
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistWavConversionProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistWavConversionProgressQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 채널 내 플레이리스트의 표시 순서를 변경합니다.
 * @summary 플레이리스트 순서 변경
 */
export const playlistReorder = (
  playlistCreateRequest: BodyType<PlaylistCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/reorder/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: playlistCreateRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistReorderMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistReorder>>,
    TError,
    { data: BodyType<PlaylistCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistReorder>>,
  TError,
  { data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationKey = ["playlistReorder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistReorder>>,
    { data: BodyType<PlaylistCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return playlistReorder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistReorder>>
>;
export type PlaylistReorderMutationBody = BodyType<PlaylistCreateRequest>;
export type PlaylistReorderMutationError = ErrorType<
  ErrorResponse | ErrorResponse
>;

/**
 * @summary 플레이리스트 순서 변경
 */
export const usePlaylistReorder = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistReorder>>,
      TError,
      { data: BodyType<PlaylistCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistReorder>>,
  TError,
  { data: BodyType<PlaylistCreateRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistReorderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
